import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { EIntegrationPlatform } from "../../models/integrations.model";
import { useIntegrations } from "../../providers/IntegrationsProvider";
import { TConfig } from "../../services/apiWorker";
import { createIntegration } from "../../services/integrations.service";
import { authGooglePhotos } from "../../services/integrations/google-photos.service";

export const IntegrationGooglePhotos = {
  type: EIntegrationPlatform.GOOGLE_PHOTOS,
  icon: "/assets/integrations/google_photos.png",
  title: "Google Photos",
  description:
    "Access your gallery stored in the cloud, with automatic backup options.",

  openAuth: (config: TConfig) => {
    const params: { [key: string]: string } = {
      client_id: config?.auth.google.clientId || "",
      redirect_uri: config?.auth.google.photos.redirectUri || "",
      response_type: "code",
      scope: config?.auth.google.photos.scopes.join(" ") || "",
      include_granted_scopes: "true",
      access_type: "offline",
      prompt: "consent",
    };

    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${new URLSearchParams(
      params
    ).toString()}`;
  },

  AuthRender: () => {
    const { addIntegration } = useIntegrations();

    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
      const scope = searchParams.get("scope");

      if (scope && scope.includes("www.googleapis.com")) {
        const code = searchParams.get("code");
        if (code) {
          searchParams.delete("code");
          searchParams.delete("scope");
          searchParams.delete("authuser");
          searchParams.delete("prompt");

          authGooglePhotos({
            accessToken: code,
            onSuccess: async (data) => {
              localStorage.setItem("googlePhotos", JSON.stringify(data));

              createIntegration({
                platform: EIntegrationPlatform.GOOGLE_PHOTOS,
                accessToken: data.access_token,
                refreshToken: data.refresh_token,
                refreshExpireAt: new Date(
                  new Date().getTime() + data.expires_in * 1000
                ).toISOString(),
                onSuccess: (data) => {
                  addIntegration(data);
                },
              });
            },
          });

          setSearchParams(searchParams);
        }
      }
    }, [searchParams]);

    return <></>;
  },
};
